import {Component, Input} from '@angular/core';
import { IBannerInfo } from '../../../components/dashboard/business-services/inventory/tmz.models';

@Component({
  selector: 'app-services-banner',
  templateUrl: './services-banner.component.html',
  styleUrls: ['./services-banner.component.scss']
})
export class ServicesBannerComponent  {
  @Input() servicesInfo: IBannerInfo = {
    bannerPacking: false,
    title: '',
    img: '',
    firstListTitle: '',
    firstList: [],
    secondListTitle: '',
    secondList: [],
    description: '',
    text: '',
    modifier: '',
    link: {
      url: '',
      name: ''
    },
    firstListNote: ''
  };
}

